import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";

export const AdminRoute = () => {
  const { isAuthenticated, user, isLoading, checkAuth } = useAuthStore();
  const [initialCheckDone, setInitialCheckDone] = useState(false);

  useEffect(() => {
    // Perform initial auth check on mount
    const performCheck = async () => {
      await checkAuth();
      setInitialCheckDone(true);
    };
    performCheck();
  }, [checkAuth]);

  // Show loading while performing initial check or while auth is loading
  if (!initialCheckDone || isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-2">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Verifying access...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== "admin") {
    // If authenticated but not admin, redirect to home/dashboard
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};